import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { CityApiRepository } from '../repositories/city-api.repository';
import { CityCacheRepository } from '../repositories/city-cache.repository';
import { CityInterface, IdInterface } from '../data';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class CityProvider {
    constructor(private cityApiRepository: CityApiRepository, private cityCacheRepository: CityCacheRepository) {}

    find(countryId: IdInterface): Observable<Transaction<CityInterface[]>> {
        const cacheId = this.cityCacheRepository.getKey(countryId);

        return concat(
            this.cityCacheRepository.load(cacheId),
            this.cityApiRepository.load(countryId).pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.cityCacheRepository.save(cacheId, transaction.data).subscribe();
                    }
                })
            )
        ).pipe(first());
    }
}
